import {App, Button, DatePicker, Divider, Flex, Form, Input, Select} from "antd";
import "../styles/styles.less"
import useForm from "antd/es/form/hooks/useForm";
import {useNavigate} from "react-router";
import dayjs from "dayjs";
import {getRequest, postRequest} from "../../../api/httpRequest";
import React, {useEffect, useState} from "react";

interface ICountry {
    Code: string,
    Name: string,
    FullName: string,
    alpha2: string,
    InternationalName: string
}

export default function Registration() {

    const [form] = useForm();
    const navigate = useNavigate();
    const [countries, setCountries] = useState<ICountry[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<ICountry>();
    const [sending, setSending] = useState(false);
    const {notification} = App.useApp()
    const [emailExists, setEmailExists] = useState(false);

    useEffect(() => {
        getRequest("/docs/countries")
            .then((res: any) => {
                setCountries(res.data);
            })
    }, []);

    const handleRegister = (values: any) => {

        setSending(true);
        postRequest("/server/api/auth/register",
            [
                {
                    country: values.citizenship,
                    phone: selectedCountry?.Code === "643" ? `7${values.phone}` : `${values.phone}`,
                    gender: values.sex,
                    snils: values.snils || "",
                    lastName: values.lastName,
                    middleName: values.middleName,
                    firstName: values.firstName,
                    email: values.email,
                    date_birth: dayjs(values.birth).format('YYYY-MM-DD'),
                }
            ]
        ).then((res) => {
            notification.success({
                message: `Успешная регистрация`,
                description: "Пароль для входа отправлен на ваш email",
                duration: 5
            });
            setSending(false);
            navigate("/login");
        }).catch(error => {
            setSending(false);
            setEmailExists(true)
            notification.error({
                message: `Ошибка регистрации`,
                description: error.response.data.message,
                duration: 5
            });
        })
    }

    return (
        <Flex className={"content"} vertical>
            <Flex vertical gap={"16px"}>
                <div className={"lkText"}>Личный кабинет</div>
                <div className={"continueText"}>Для регистрации учетной записи, пожалуйста, заполните форму</div>
            </Flex>
            <Divider style={{margin: 16}}/>
            <Form
                labelCol={{flex: '150px'}}
                labelAlign="right"
                name={"registration"}
                form={form}
                onFinish={values => handleRegister(values)}
            >
                <Form.Item
                    label="Фамилия"
                    name="lastName"
                    rules={[{required: true, message: 'Фамилия не может быть пустой!'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="Имя"
                    name="firstName"
                    rules={[{required: true, message: 'Имя не может быть пустым!'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="Отчество"
                    name="middleName"
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="Электронная почта"
                    name="email"
                    rules={[{required: true, message: 'Электронная почта не может быть пустой!'}]}
                >
                    <Input status={emailExists ? "error" : ""}/>
                </Form.Item>
                <Form.Item
                    label="Дата рождения"
                    name="birth"
                    rules={[{required: true, message: 'Дата рождения не может быть пустой!'}]}
                >
                    <DatePicker format={["DD-MM-YYYY","DDMMYYYY","DD.MM.YYYY"]}/>
                </Form.Item>
                <Form.Item
                    label="Пол"
                    name="sex"
                    rules={[{required: true, message: 'Пол не может быть пустым!'}]}
                >
                    <Select>
                        <Select.Option value="1">Мужской</Select.Option>
                        <Select.Option value="0">Женский</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Гражданство"
                    name="citizenship"
                    rules={[{required: true, message: 'Гражданство не может быть пустым!'}]}
                >
                    <Select
                        placeholder={"Укажите гражданство"}
                        options={countries.map((country: ICountry) => (
                            {
                                value: country.Code,
                                label: country.Name
                            }
                        ))}
                        onSelect={() => setSelectedCountry(countries.find((country: ICountry) => country.Code === form.getFieldValue("citizenship")))}
                    />
                </Form.Item>
                {selectedCountry?.Code === "643" &&
                    <Form.Item
                        label="СНИЛС"
                        name="snils"
                        rules={[
                        { required: true, message: 'СНИЛС не может быть пустым!' },
                        { pattern: /^\d{11}$/, message: 'СНИЛС должен содержать 11 цифр' }
                        ]}
                    >
                        <Input
                        placeholder="000-000-000 00"
                        value={form.getFieldValue('snils')}
                        onChange={(e) => {
                            const raw = e.target.value.replace(/\D/g, '').slice(0, 11);
                            form.setFieldValue('snils', raw);
                        }}
                        />
                    </Form.Item>
                 }
                <Form.Item
                    label="Номер телефона"
                    name="phone"
                    rules={[{required: true, message: 'Номер телефона не может быть пустым!'}]}
                >
                    <Input addonBefore={selectedCountry?.Code === "643" ? "+7" : "+"} style={{width: '100%'}}/>
                </Form.Item>
                <Form.Item>
                    <Flex align={"center"} justify={"center"}>
                        <Button
                            loading={sending}
                            type="primary"
                            htmlType="submit">
                            Зарегистрироваться
                        </Button>
                    </Flex>
                </Form.Item>
            </Form>
        </Flex>
    )
}